/** The Overview page: the support board's figures in one read (spec 2026-10-25-overview-design.md). */
import { oc } from '@orpc/contract';
import { z } from 'zod';
const usd = z.number();
export const overviewDay = z.object({
    /** YYYY-MM-DD, New York. */
    day: z.string(),
    opened: z.number().int(),
    closed: z.number().int(),
    aiCalls: z.number().int(),
    aiUsd: usd,
});
export const overviewPerson = z.object({
    email: z.string(),
    name: z.string(),
    /** Live tickets held: desk assignee, or named on the Slack list's Support Team. */
    holding: z.number().int(),
    openedToday: z.number().int(),
    closedToday: z.number().int(),
    notesToday: z.number().int(),
});
const aiWindow = z.object({ calls: z.number().int(), failed: z.number().int(), usd });
export const overviewOutput = z.object({
    asOf: z.string(),
    tickets: z.object({
        open: z.number().int(),
        byStage: z.array(z.object({ stage: z.string(), count: z.number().int() })),
        unassigned: z.number().int(),
        waitingOnMerchant: z.number().int(),
        openedToday: z.number().int(),
        closedToday: z.number().int(),
        openedWeek: z.number().int(),
        closedWeek: z.number().int(),
        oldestOpenAt: z.string().nullable(),
        /** Over tickets closed in the last 14 days; null when none. */
        medianHoursToClose: z.number().nullable(),
    }),
    /** The three newest tickets, newest first (the e2e account's left out). */
    recent: z.array(z.object({
        ticketId: z.string(),
        ticketNumber: z.string(),
        subject: z.string(),
        status: z.string(),
        openedAt: z.string(),
        /** Who logged it: the desk person, else the Slack list's creator. */
        loggedBy: z.string().nullable(),
        /** The account's label, else the company the caller gave. */
        store: z.string().nullable(),
        /** First holder (the holders rule), or null when nobody holds it. */
        owner: z.string().nullable(),
        category: z.string().nullable(),
    })),
    days: z.array(overviewDay),
    people: z.array(overviewPerson),
    ai: z.object({
        today: aiWindow,
        week: aiWindow,
        month: aiWindow,
        byTrigger: z.array(z.object({ trigger: z.string(), calls: z.number().int(), usd })),
        byModel: z.array(z.object({ model: z.string(), calls: z.number().int(), usd, inputTokens: z.number().int(), outputTokens: z.number().int(), cacheReadTokens: z.number().int() })),
        topTickets: z.array(z.object({ ticketId: z.string(), ticketNumber: z.string(), subject: z.string(), calls: z.number().int(), usd })),
        lastRunAt: z.string().nullable(),
        lastFailedAt: z.string().nullable(),
        /** ANTHROPIC_API_KEY is set on the API. */
        on: z.boolean(),
    }),
    systems: z.object({
        worker: z.enum(['ok', 'down', 'unknown']),
        workerBeatAt: z.string().nullable(),
        dialpadLastEventAt: z.string().nullable(),
        /** Desk ticket posts waiting on Slack (unposted `ticket.%` outbox rows). */
        slackBacklog: z.number().int(),
        slackLastPostAt: z.string().nullable(),
        mirrorLastAt: z.string().nullable(),
        mirrorLastOk: z.boolean().nullable(),
    }),
});
export const overviewContract = {
    get: oc.route({ method: 'POST', path: '/overview', summary: 'The support board in figures: tickets, team, AI spend, systems' }).input(z.object({}).optional()).output(overviewOutput),
};
//# sourceMappingURL=overview.js.map